import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    withdrawalFee: {
        id: '_.draw_down.choose_amount.withdrawal_fee',
        defaultMessage: 'Withdrawal fee {tooltip}'
    },
    feeTooltip: {
        id: '_.draw_down.choose_amount.fee_tooltip',
        defaultMessage: `We'll charge this whenever you withdraw money from your loan: it's to cover some of our processing costs. We'll add it to your monthly repayments, so check your schedule for details.`
    },
    always: {
        id: '_.draw_down.choose_amount.always',
        defaultMessage: 'always'
    }
});
